export default __webpack_public_path__ + "static/media/return.014db795.svg";